export default {
  callAlertConfig: {
    humanMaxDuration: 0, // no muestra si no tiene configuracion
    timeShowAlertFromMax: 60, // si hubo error al cargar pero max existe
    textOnAlert: 'Tiempo máximo de llamada excedido...',
  },
  currentStatusStartTime: 0,
  isOnManualCall: false,
  sound: null,
  lastCallExceeded: null,
};



// WEBPACK FOOTER //
// ./src/store/call_time_and_alert/state.js